import account from "./locales/nl/account.json";
import attribute from "./locales/nl/attribute.json";
import bundle from "./locales/nl/bundle.json";
import category from "./locales/nl/category.json";
import common from "./locales/nl/common.json";
import companyDetails from "./locales/nl/company-details.json";
import content from "./locales/nl/content.json";
import customer from "./locales/nl/customer.json";
import discountCode from "./locales/nl/discount-code.json";
import employee from "./locales/nl/employee.json";
import faqItem from "./locales/nl/faq-item.json";
import health from "./locales/nl/health.json";
import holder from "./locales/nl/holder.json";
import invoice from "./locales/nl/invoice.json";
import location from "./locales/nl/location.json";
import mail from "./locales/nl/mail.json";
import newsletter from "./locales/nl/newsletter.json";
import order from "./locales/nl/order.json";
import page from "./locales/nl/page.json";
import personalAccessToken from "./locales/nl/personal-access-token.json";
import price from "./locales/nl/price.json";
import product from "./locales/nl/product.json";
import revenue from "./locales/nl/revenue.json";
import session from "./locales/nl/session.json";
import settings from "./locales/nl/settings.json";
import shippingRule from "./locales/nl/shipping-rule.json";
import shop from "./locales/nl/shop.json";
import shopAccount from "./locales/nl/shop-account.json";
import shopCheckout from "./locales/nl/shop-checkout.json";
import start from "./locales/nl/start.json";
import stock from "./locales/nl/stock.json";

export const defaultNS = "common";

/**
 * Every namespace, Dutch only. `common` is the shell (app name, words every screen uses); every
 * other namespace belongs to one area, in `./locales/nl/<area>.json`, and is registered with one
 * import line above and one line below, both sorted. Keys are English, values Dutch.
 *
 * An area's namespace has a `title`: the name the menu and the page heading show.
 */
export const resources = {
	nl: {
		account,
		attribute,
		bundle,
		category,
		common,
		companyDetails,
		content,
		customer,
		discountCode,
		employee,
		faqItem,
		health,
		holder,
		invoice,
		location,
		mail,
		newsletter,
		order,
		page,
		personalAccessToken,
		price,
		product,
		revenue,
		session,
		settings,
		shippingRule,
		shop,
		shopAccount,
		shopCheckout,
		start,
		stock,
	},
} as const;

export type Namespace = keyof (typeof resources)["nl"];
